import { AppSettings } from '../appSettings'

export class PermissionService {
  static userPermissions: string[];
  static isDevelopment: boolean;
  static isTest: boolean;

  static async setUserPermissions(userGroups: string[]) {
    const adGroupsPermissions = JSON.parse(await AppSettings.get('AD_GROUP_PERMISSIONS'))
    this.userPermissions = userGroups.map(ug => adGroupsPermissions[ug])
      .filter(ug => ug !== undefined) || []
  }

  static async setIsDevelopment() {
    this.isDevelopment = await AppSettings.get('IS_DEVELOPMENT');
  }

  static async setIsTest() {
    this.isTest = true;
  }

  static hasPermission(permissionRequired: string): boolean {
    return this.isDevelopment || this.isTest || (this.userPermissions ? this.userPermissions.includes(permissionRequired) : false);
  }
}
